import { AI_ASSISTANT_CONSTANTS } from "../constants/aiAssistantConstants";

const TOAST_EVENT_NAME = AI_ASSISTANT_CONSTANTS.EVENTS.TOAST;

export const emitAssistantToast = (toast) => {
    window.dispatchEvent(
        new CustomEvent(TOAST_EVENT_NAME, {
            detail: toast || {},
        }),
    );
};

export const subscribeAssistantToast = (handler) => {
    if (typeof handler !== "function") return () => {};
    const listener = (event) => {
        handler(event?.detail || {});
    };
    window.addEventListener(TOAST_EVENT_NAME, listener);
    return () => window.removeEventListener(TOAST_EVENT_NAME, listener);
};

